import { IIcon } from '@models/IIcon';
import classNames from 'classnames';
import IcoMoon from 'react-icomoon';
import iconSet from './selection.json';

const Icon = ({
  className,
  color,
  colorClassName = 'text-black-100',
  name = 'check',
  size = '1.5rem',
}: IIcon) => (
  <IcoMoon
    icon={name}
    size={size}
    color={color}
    iconSet={iconSet}
    className={classNames(className, colorClassName, name)}
  />
);

export default Icon;
